import { lazy } from 'react';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - auth
const Login = Loadable(lazy(() => import('pages/auth/Login')));
const AuthCallback = Loadable(lazy(() => import('pages/auth/AuthCallback')));
const StepUpCallback = Loadable(lazy(() => import('pages/auth/StepUpCallback')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  // Pathless: this object only groups the two branches below under one array entry.
  children: [
    {
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [{ path: 'login', element: <Login /> }]
    },
    {
      // Outside both guards on purpose. Auth.ID redirects here before any session exists, and the
      // step-up return must not be bounced by AuthGuard either.
      element: <CommonLayout />,
      children: [
        { path: 'auth/callback', element: <AuthCallback /> },
        { path: 'auth/step-up/callback', element: <StepUpCallback /> }
      ]
    }
  ]
};

export default LoginRoutes;
